import { render, staticRenderFns } from "./TenantSpace.vue?vue&type=template&id=f178066c&"
import script from "./TenantSpace.vue?vue&type=script&lang=ts&"
export * from "./TenantSpace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports